import { ROOM_TYPES } from '../../../common/utils/roomTypes'

export const getters = {
  processing: state => { return state.processing },
  error: state => { return state.error },
  dataRoomTypeId: (_, getters, rootState, rootGetters) => {
    const dataRoomType = rootGetters['user/roomTypes'].find(
      roomType => roomType.type === ROOM_TYPES.DATAROOM || roomType.type === ROOM_TYPES.DATAROOM_UNLIMITED,
    )
    return dataRoomType?.id ?? null
  },
  rooms: state => {
    return [
      ...state.pmRooms,
      ...state.guestRooms,
    ]
  },
}
